<ng-template #shipmentListModal let-modal>
  <div class="modal-header">
    <h3 class="fw-semibold">Danh sách phiếu xuất kho cho đơn: {{order?.orderId}}</h3>
    <app-button [class]="'btn btn-close'" [spinner]="false" [id]="'address_modal_close_btn'"
                (click)="modal.dismiss('Cross click')">
      <i class="ri-close-line"></i>
    </app-button>
  </div>
  <div class="modal-body">
    <app-shipment-list [shipments]="shipments" [order]="order" ></app-shipment-list>
  </div>
</ng-template>
